import { render } from "./SpinnerPlaceholder.vue?vue&type=template&id=4569c3d9&scoped=true&ts=true&lang=pug"
import script from "./SpinnerPlaceholder.vue?vue&type=script&lang=ts"
export * from "./SpinnerPlaceholder.vue?vue&type=script&lang=ts"

import "./SpinnerPlaceholder.vue?vue&type=style&index=0&id=4569c3d9&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4569c3d9"]])

export default __exports__